<div
  fxLayout
  *ngIf="{
    reservations: reservations$ | async,
    devices: devices$ | async,
    operations: operations$ | async,
    thermostats: thermostats$ | async
  } as vm">
  <sbnb-subnav fxFlex="280px" fxHide.lt-md header="Devices">
    <sbnb-devices-subnav></sbnb-devices-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists page-device-dashboard" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Dashboard"
      [saveButtonShown]="false"
      [sticky]="false"
      novaContentId="smart-devices-dashboard"></sbnb-content-header>

    <sbnb-smart-device-notifications></sbnb-smart-device-notifications>

    <mat-tab-group class="dashboard__tabs" [selectedIndex]="selectedTabIndex">
      <mat-tab label="Reservations {{ vm.reservations.meta?.total ? '(' + vm.reservations.meta.total + ')' : null }}">
        <div
          fxLayout="row wrap"
          fxLayoutAlign="space-between start"
          fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="start stretch">
          <sbnb-filter
            #guestsFilterComponent
            componentName="smartlock-codes"
            [hideSaveSegment]="true"
            [customEndpoint]="smartlockFilterUrl + 'codes'"
            (filterChanged)="onReservationsFiltersChanged($event)"
            (reset)="guestsFilterComponent.selfReset()"></sbnb-filter>

          <div fxLayoutGap="12px" fxLayout.lt-md="column">
            <sbnb-search-bar
              fxFlex="480px"
              fxFlex.lt-md="100%"
              placeholderText="Search by guest name or reservation code..."
              (searchChanged)="onReservationsSearchChanged($event)"></sbnb-search-bar>
          </div>
        </div>

        <mat-spinner *ngIf="vm.reservations.loading" [diameter]="24"></mat-spinner>
        <div *ngIf="vm.reservations.error" class="error">{{ vm.reservations.error }}</div>

        <div *ngIf="vm.reservations.data?.length === 0" class="error">
          <sbnb-no-items text="No reservations found"></sbnb-no-items>
        </div>

        <sbnb-smart-device-guests-table
          *ngIf="vm.reservations.data?.length > 0"
          [codes]="vm.reservations.data"
          (nameClicked)="openGuestDetailsModal($event)"></sbnb-smart-device-guests-table>

        <sbnb-pagination
          *ngIf="!vm.reservations.loading && vm.reservations.meta && vm.reservations.meta.page_numbers.total_pages > 1"
          position="end"
          [pageCount]="vm.reservations.meta.page_numbers.total_pages"
          [currentPage]="vm.reservations.meta.page_numbers.this_page"
          (pageChanged)="onReservationsPageChanged($event)"></sbnb-pagination>
      </mat-tab>

      <mat-tab label="Operations {{ vm.operations.meta?.total ? '(' + vm.operations.meta.total + ')' : null }}">
        <div
          fxLayout="row wrap"
          fxLayoutAlign="space-between start"
          fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="start stretch">
          <sbnb-filter
            #guestsFilterComponent
            componentName="smartlock-codes"
            [hideSaveSegment]="true"
            [customEndpoint]="smartlockFilterUrl + 'codes'"
            (filterChanged)="onOperationsFiltersChanged($event)"
            (reset)="guestsFilterComponent.selfReset()"></sbnb-filter>

          <div fxLayoutGap="12px" fxLayout.lt-md="column">
            <sbnb-search-bar
              fxFlex="320px"
              fxFlex.lt-md="100%"
              placeholderText="Search by name..."
              (searchChanged)="onOperationsSearchChanged($event)"></sbnb-search-bar>

            <sbnb-button
              *ngIf="canCreateManualCode$ | async"
              [fullWidth]="true"
              fxFlex="0 0 auto"
              type="primary"
              size="mini"
              (clicked)="openAddManualCodeModal()">
              Add a manual code
            </sbnb-button>
          </div>
        </div>

        <mat-spinner *ngIf="vm.operations.loading" [diameter]="24"></mat-spinner>
        <div *ngIf="vm.operations.error" class="error">{{ vm.operations.error }}</div>

        <div *ngIf="vm.operations.data?.length === 0" class="error">
          <sbnb-no-items text="No codes found"></sbnb-no-items>
        </div>

        <sbnb-smart-device-guests-table
          *ngIf="vm.operations.data?.length > 0"
          [codes]="vm.operations.data"
          [singleProperty]="false"
          [showThermostatColumns]="false"
          (nameClicked)="openGuestDetailsModal($event)"></sbnb-smart-device-guests-table>

        <sbnb-pagination
          *ngIf="!vm.operations.loading && vm.operations.meta && vm.operations.meta.page_numbers.total_pages > 1"
          position="end"
          [pageCount]="vm.operations.meta.page_numbers.total_pages"
          [currentPage]="vm.operations.meta.page_numbers.this_page"
          (pageChanged)="onOperationsPageChanged($event)"></sbnb-pagination>
      </mat-tab>

      <mat-tab label="Smart Locks {{ vm.devices?.meta?.total ? '(' + vm.devices.meta.total + ')' : null }}">
        <div fxLayout fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
          <sbnb-filter
            #devicesFilterComponent
            componentName="smartlock-devices"
            [hideSaveSegment]="true"
            [customEndpoint]="smartlockFilterUrl + 'devices'"
            (filterChanged)="onDevicesFiltersChanged($event)"
            (reset)="devicesFilterComponent.selfReset()"></sbnb-filter>

          <sbnb-search-bar
            fxFlex="480px"
            fxFlex.lt-md="100%"
            placeholderText="Search by device name..."
            (searchChanged)="onDevicesSearchChanged($event)"></sbnb-search-bar>
        </div>

        <mat-spinner *ngIf="vm.devices.loading" [diameter]="24"></mat-spinner>
        <div *ngIf="vm.devices.error" class="error">{{ vm.devices.error }}</div>

        <div *ngIf="vm.devices.data?.length === 0" class="error">
          <sbnb-no-items text="No devices found"></sbnb-no-items>
        </div>

        <sbnb-smart-device-devices-table
          *ngIf="vm.devices.data && vm.devices.data.length > 0"
          [devices]="vm.devices.data"
          (nameClicked)="openDeviceDetailsModal($event)"></sbnb-smart-device-devices-table>

        <sbnb-pagination
          *ngIf="!vm.devices.loading && vm.devices.meta && vm.devices.meta.page_numbers.total_pages > 1"
          position="end"
          [pageCount]="vm.devices.meta.page_numbers.total_pages"
          [currentPage]="vm.devices.meta.page_numbers.this_page"
          (pageChanged)="onDevicesPageChanged($event)"></sbnb-pagination>
      </mat-tab>

      <mat-tab label="Thermostats {{ vm.thermostats?.meta?.total ? '(' + vm.thermostats.meta.total + ')' : null }}">
        <div fxLayout fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
          <sbnb-filter
            #devicesFilterComponent
            componentName="thermostat-devices"
            [hideSaveSegment]="true"
            [customEndpoint]="smartlockFilterUrl + 'devices'"
            (filterChanged)="onThermostatsFiltersChanged($event)"
            (reset)="thermostatsFilterComponent.selfReset()"></sbnb-filter>

          <sbnb-search-bar
            fxFlex="480px"
            fxFlex.lt-md="100%"
            placeholderText="Search by device name..."
            (searchChanged)="onThermostatsSearchChanged($event)"></sbnb-search-bar>
        </div>

        <mat-spinner *ngIf="vm.thermostats.loading" [diameter]="24"></mat-spinner>
        <div *ngIf="vm.thermostats.error" class="error">{{ vm.thermostats.error }}</div>

        <div *ngIf="vm.thermostats.data?.length === 0" class="error">
          <sbnb-no-items text="No thermostats found"></sbnb-no-items>
        </div>

        <sbnb-smart-device-thermostats-table
          *ngIf="vm.thermostats.data && vm.thermostats.data.length > 0"
          [thermostats]="vm.thermostats.data"
          (nameClicked)="openThermostatDetailsModal($event)"></sbnb-smart-device-thermostats-table>

        <sbnb-pagination
          *ngIf="!vm.thermostats.loading && vm.thermostats.meta && vm.thermostats.meta.page_numbers.total_pages > 1"
          position="end"
          [pageCount]="vm.thermostats.meta.page_numbers.total_pages"
          [currentPage]="vm.thermostats.meta.page_numbers.this_page"
          (pageChanged)="onThermostatsPageChanged($event)"></sbnb-pagination>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Devices">
  <sbnb-devices-subnav></sbnb-devices-subnav>
</sbnb-mobile-sidebar>
